import { render, staticRenderFns } from "./section-restitution.vue?vue&type=template&id=3b826ffc&scoped=true"
import script from "./section-restitution.vue?vue&type=script&lang=js"
export * from "./section-restitution.vue?vue&type=script&lang=js"
import style0 from "./section-restitution.vue?vue&type=style&index=0&id=3b826ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b826ffc",
  null
  
)

export default component.exports